import type { TSelector } from "../../i18n/types";

export const UploadStatus = {
  PENDING: 0,
  VALIDATING: 1,
  SUCCESS: 2,
  FAILED: 3,
  CANCELLED: 4,
  VALIDATED: 5,
  PROCESSING: 6,
  VALIDATION_FAILED: 7,
  DONE: 8,
  PARTIAL: 9,
} as const;

type UploadStatusType = (typeof UploadStatus)[keyof typeof UploadStatus];

const TERMINAL_STATUSES: UploadStatusType[] = [
  UploadStatus.SUCCESS,
  UploadStatus.FAILED,
  UploadStatus.CANCELLED,
  UploadStatus.VALIDATED,
  UploadStatus.VALIDATION_FAILED,
  UploadStatus.DONE,
  UploadStatus.PARTIAL,
];

export function isTerminalStatus(status: number): boolean {
  return TERMINAL_STATUSES.includes(status as UploadStatusType);
}

// Pattern B (i18n): consumers call `t(getStatusLabel(status))` at render time.
// Selectors use the FLAT form ($[…], no namespace prefix). Consumers bind
// `useTranslation(["uploads", ...])` for these to resolve.
export function getStatusLabel(status: number): TSelector {
  const labels: Record<number, TSelector> = {
    [UploadStatus.PENDING]: ($) => $.uploads.status.Pending,
    [UploadStatus.VALIDATING]: ($) => $.uploads.status.Validating,
    [UploadStatus.SUCCESS]: ($) => $.uploads.status.Success,
    [UploadStatus.FAILED]: ($) => $.uploads.status.Failed,
    [UploadStatus.CANCELLED]: ($) => $.uploads.status.Cancelled,
    [UploadStatus.VALIDATED]: ($) => $.uploads.status["Awaiting Confirmation"],
    [UploadStatus.PROCESSING]: ($) => $.uploads.status.Processing,
    [UploadStatus.VALIDATION_FAILED]: ($) => $.uploads.status["Validation Failed"],
    [UploadStatus.DONE]: ($) => $.uploads.status.Done,
    [UploadStatus.PARTIAL]: ($) => $.uploads.status["Partially Committed"],
  };
  return labels[status] ?? (($) => $.uploads.status.Unknown);
}
